import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-scale-large.tsx
/**
* icon.24.scale.large
*
* Keywords: window, overlap, cascade, multiple, layer, stacked, frame, duplicate
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE1LjUgOGEuNS41IDAgMCAxIC41LjV2NGEuNS41IDAgMCAxLTEgMFY5LjcwN2wtMy4xNDYgMy4xNDZoLS4wMDJjLjA5My4xOTcuMTQ4LjQxNS4xNDguNjQ3djVhMS41IDEuNSAwIDAgMS0xLjUgMS41aC01QTEuNSAxLjUgMCAwIDEgNCAxOC41di01QTEuNSAxLjUgMCAwIDEgNS41IDEyaDVjLjIzMSAwIC40NS4wNTQuNjQ2LjE0OEwxNC4yOTMgOUgxMS41YS41LjUgMCAwIDEgMC0xem0yLjI1Ni0zLjk4N0EyLjUgMi41IDAgMCAxIDIwIDYuNXYxMWEyLjUgMi41IDAgMCAxLTIuNSAyLjVIMTRhLjUuNSAwIDAgMSAwLTFoMy41YTEuNSAxLjUgMCAwIDAgMS41LTEuNXYtMTFhMS41IDEuNSAwIDAgMC0xLjM0Ny0xLjQ5MkwxNy41IDVoLTExQTEuNSAxLjUgMCAwIDAgNSA2LjVWMTBhLjUuNSAwIDAgMS0xIDBWNi41QTIuNSAyLjUgMCAwIDEgNi41IDRoMTF6TTUuNSAxM2EuNS41IDAgMCAwLS41LjV2NWEuNS41IDAgMCAwIC41LjVoNWEuNS41IDAgMCAwIC41LS41di01YS41LjUgMCAwIDAtLjUtLjV6Ii8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-2645
*/
const Icon24ScaleLarge = memo(function Icon24ScaleLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M15.5 8a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V9.707l-3.146 3.146h-.002c.093.197.148.415.148.647v5a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 4 18.5v-5A1.5 1.5 0 0 1 5.5 12h5c.231 0 .45.054.646.148L14.293 9H11.5a.5.5 0 0 1 0-1zm2.256-3.987A2.5 2.5 0 0 1 20 6.5v11a2.5 2.5 0 0 1-2.5 2.5H14a.5.5 0 0 1 0-1h3.5a1.5 1.5 0 0 0 1.5-1.5v-11a1.5 1.5 0 0 0-1.347-1.492L17.5 5h-11A1.5 1.5 0 0 0 5 6.5V10a.5.5 0 0 1-1 0V6.5A2.5 2.5 0 0 1 6.5 4h11zM5.5 13a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5z"
		})
	});
});
//#endregion
export { Icon24ScaleLarge };

//# sourceMappingURL=icon-24-scale-large.js.map